module.exports = __webpack_public_path__ + "static/derro_savant-63a49eceb4de48146a7d65802b0082b4.png";